// extracted by mini-css-extract-plugin
module.exports = {"subcategoriesContainer":"category-hero_subcategoriesContainer__i8ZCS","subcategory":"category-hero_subcategory__Of2oR"};